import { useState } from "react"
import { Eye, EyeOff } from "lucide-react"

export default function FormInput({ label, id, type = "text", error, className = "", ...props }) {
  const [showPassword, setShowPassword] = useState(false)

  // Determine the actual input type
  const inputType = type === "password" && showPassword ? "text" : type

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}

      <div className="relative">
        <input
          id={id}
          type={inputType}
          className={`w-full h-[48px] md:h-[60px] px-3 py-2 border ${
            error ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-[#5B93FF]"
          } rounded-md focus:outline-none focus:ring-2 ${className}`}
          {...props}
        />

        {/* Password toggle button */}
        {type === "password" && (
          <button
            type="button"
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={togglePasswordVisibility}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
          </button>
        )}
      </div>

      {/* Error message */}
      {error && <p className="text-sm text-red-600 mt-1">{error}</p>}
    </div>
  )
}
